import { Drawer } from "antd";
import SubMenus, { SubMenuPropType } from "../sub-menus";

type DrawerPropType = {
  isDrawer: boolean;
  userEmail?: string;
  isVisible?: boolean;
  collapsed: boolean;
};

const DrawerMenus: React.FC<DrawerPropType & SubMenuPropType> = ({
  navItem,
  isDrawer,
  userEmail,
  isVisible,
  collapsed
}) => {
  return (
    <>
      {isDrawer ? (
        <Drawer title={userEmail} placement="right" open={isVisible}>
          <SubMenus navItem={navItem} />
        </Drawer>
      ) : (
        <SubMenus navItem={navItem} collapsed={collapsed} />
      )}
    </>
  );
};

export default DrawerMenus;
